function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import { withGenericConfig } from "/contexts/generic-config-context";
import PictureComponent from "components/core/picture/picture-component";
import { StyledTestimonialComponent } from "./testimonial-component.scss";
class TestimonialComponent extends PureComponent {
    render() {
        const { isCurrentSlide } = this.props;
        return /*#__PURE__*/ _jsxs(StyledTestimonialComponent, {
            className: classnames("testimonial-component", {
                active: isCurrentSlide
            }),
            children: [
                this.renderImage(),
                /*#__PURE__*/ _jsxs("div", {
                    className: "testimonial-text-container",
                    children: [
                        this.renderMainText(),
                        this.renderPerson()
                    ]
                })
            ]
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "renderImage", ()=>{
            const { testimonial } = this.props;
            const { image } = testimonial;
            return /*#__PURE__*/ _jsx("div", {
                className: "testimonial-image-container",
                children: /*#__PURE__*/ _jsx(PictureComponent, _object_spread_props(_object_spread({}, image), {
                    className: "testimonial-image"
                }))
            });
        });
        _define_property(this, "renderMainText", ()=>{
            const { testimonial, translate } = this.props;
            const { testimonialText } = testimonial;
            return /*#__PURE__*/ _jsx(_Fragment, {
                children: /*#__PURE__*/ _jsx("div", {
                    className: "testimonial-text",
                    dangerouslySetInnerHTML: {
                        __html: translate(testimonialText)
                    }
                })
            });
        });
        _define_property(this, "renderPerson", ()=>{
            const { testimonial, translate } = this.props;
            const { personName, personRole } = testimonial;
            return /*#__PURE__*/ _jsxs("div", {
                className: "testimonial-person-container",
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: "testimonial-person-name",
                        children: translate(personName)
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "separator",
                        children: translate("pricingPage.testimonials.separator")
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "testimonial-person-title",
                        children: translate(personRole)
                    })
                ]
            });
        });
    }
}
export default withGenericConfig(TestimonialComponent);
